export default function parseCategories(categories: (SchoolCategory | ProfessionCategory)[]): (SchoolCategory | ProfessionCategory)[] {
    let mainCategories: any[] = [];
    if (Object.values(categories).length) {
        mainCategories = Object.values(categories)
            .map((category: SchoolCategory) => (!category.parent ? { ...category, subCategories: [] } : null))
            .filter(e => e);
        const subCategories: any[] = Object.values(categories)
            .map((category: SchoolCategory) => (category.parent ? { ...category, subCategories: [] } : null))
            .filter(e => e);
        subCategories.forEach((subCategory: any) => {
            const index = mainCategories.map((mainCategory: any) => mainCategory.term_id).indexOf(subCategory.parent);
            if (mainCategories && mainCategories[index] && mainCategories[index].subCategories) {
                mainCategories[index].subCategories.push(subCategory);
            }
        });
    }
    return mainCategories;
}
